var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 121,
    viewBox: "0 0 79 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.7158L62.069 16.7158L62.069 120.164L0 120.164L0 16.7158ZM4.13793 20.8538L4.13793 116.026L57.931 116.026L57.931 20.8538H45.5064V30.0438L16.5798 30.0438L16.5798 20.8538L4.13793 20.8538ZM20.7177 20.8538V25.9059L41.3685 25.9059V20.8538L20.7177 20.8538ZM43.4483 110.823H18.6207V106.685H43.4483V110.823Z",
    fill: "url(#paint0_linear_908_1063)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2078 12.5774L10.3457 12.5774V8.43945L70.3457 8.43945L70.3457 109.819H66.2078L66.2078 12.5774Z",
    fill: "#A7BDF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4832 4.30199L18.6211 4.30199V0.164062L78.6211 0.164062L78.6211 101.543H74.4832L74.4832 4.30199Z",
    fill: "#D3DEFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_1063",
    x1: -4.3845e-7,
    y1: 110.979,
    x2: 63.3669,
    y2: 108.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobile-app.52740a7b9af5173da5ea0c4eada4a8cc.svg";
export { ForwardRef as ReactComponent };